/**
 * Stripe Service - Frontend integration
 */

import { loadStripe } from '@stripe/stripe-js'

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001/api'
const STRIPE_PUBLISHABLE_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || ''

let stripePromise = null

/**
 * Initialize Stripe
 */
function getStripe() {
  if (!stripePromise && STRIPE_PUBLISHABLE_KEY) {
    stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY)
  }
  return stripePromise
}

/**
 * Create checkout session and redirect to Stripe
 */
export async function createCheckoutSession(planType = 'monthly') {
  try {
    const response = await fetch(`${API_BASE_URL}/stripe/create-checkout-session`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        planType,
        successUrl: `${window.location.origin}/success?session_id={CHECKOUT_SESSION_ID}`,
        cancelUrl: `${window.location.origin}/cancel`
      })
    })

    const result = await response.json()

    if (!result.success) {
      throw new Error(result.error || 'Failed to create checkout session')
    }

    // Redirect to Stripe Checkout
    const stripe = await getStripe()
    if (stripe && result.sessionId) {
      const { error } = await stripe.redirectToCheckout({
        sessionId: result.sessionId
      })
      
      if (error) {
        throw error
      }
    } else if (result.url) {
      // Fallback: redirect directly to URL
      window.location.href = result.url
    } else {
      throw new Error('No checkout URL received')
    }
  } catch (error) {
    console.error('Stripe checkout error:', error)
    throw error
  }
}

/**
 * Check session status
 */
export async function checkSessionStatus(sessionId) {
  try {
    const response = await fetch(`${API_BASE_URL}/stripe/session-status?session_id=${sessionId}`)
    const result = await response.json()
    
    if (!result.success) {
      throw new Error(result.error || 'Failed to check session status')
    }
    
    return result.session
  } catch (error) {
    console.error('Stripe session status error:', error)
    throw error
  }
}
